<template>
  <div>
    <h1>Upload Document(s)</h1>
    <div class="card">
      <div class="card-header">{{documentType.name}}</div>
      <div class="card-body">
        <b-row>
          <b-col>
            <p v-if="documentType.min > 0">You must upload at least {{documentType.min}} document(s)</p>
            <p v-if="documentType.min === 0">This document is optional</p>
            <p>You may upload no more than {{documentType.max}} document(s)</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <form-summary :validator="$v.form" ref="errorContainer" id="errorContainer"/>
            <FileAttachment v-on:document-added="addDocument" :applicationId="application.id" :documentTypeId="documentType.id"
                            :canUpload="this.documents.length < documentType.max"/>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col cols="12" lg="12">
            <DocumentTable v-on:document-updated="updatedDocument" :newDoc="newDocuments" :applicationId="application.id" :isView="false"
                           :documentTypeId="documentType.id" :documentTypeName="documentType.name"/>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-button :to="'/attachments/'+ application.id">Return to attachment list</b-button>
  </div>

</template>
<script>
  import {required, email, minLength} from 'vuelidate/lib/validators'
  import DocumentTable from '@/components/templates/DocumentTable'
  import FileAttachment from '@/components/templates/input/FileAttachment.vue'

  export default {
    props: {
      application: [Object],
      documentType: [Object]
    },
    data: () => {
      return {
        newDocuments: [],
        documents: [],
        isLoading: false
      }
    },

    components: {
      FileAttachment,
      DocumentTable,
    },
    created(){
      document.title = "Upload Document(s) - Facility and Provider Licensing System"
    },
    validations() {
      return {
      }
    },
    methods: {
      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data.screen, isValid)
        return isValid
      },
      addDocument(value) {
        this.newDocuments.push(value)
      },
      updatedDocument(value) {
        this.documents = value
        this.newDocuments = []
      },
    }
  }
</script>